import './bootstrap'

jQuery(document).ready(function ($) {
  (function($) {
    $(document).ready(function() {
      $(".ref").on("click", function(e) {
        let link = $(this).data("ref");
        window.open(link, "_blank");
      });

      $(".header_promo-slider").slick({
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        dots: true,
        appendDots: $(".header_promo-slider-dots")
      });

      $(".slot").on("click", function() {
        let slot = $(this).data("game");
        $(this)
            .removeClass("slot")
            .addClass("slot-start")
            .html('<iframe src="' + slot + '" frameborder="0"></iframe>');
      });

    });
  })(jQuery);

  function randomInteger(min, max) {
    let rand = min - 0.5 + Math.random() * (max - min + 1);
    return Math.round(rand);
  }

  document.addEventListener("DOMContentLoaded", readyHTML);
  function readyHTML() {
    up_button();
  }

  function up_button() {
    let up_button = document.createElement('img');
    let body = document.querySelector('body');
    body.appendChild(up_button);
    up_button.src = '/wp-content/themes/30387/assets/images/scroll-top.svg';
    up_button.alt = 'to_top';
    up_button.style.opacity = "0";
    up_button.className = "up_button";

    window.onscroll = function() {
      let scrolled = window.pageYOffset || document.documentElement.scrollTop;
      let h = window.innerHeight;
      if (scrolled > 0.2*h) {
        up_button.style.opacity = "1";
        up_button.style.cursor = "pointer";
        up_button.addEventListener('click',to_top)
      }
      else {
        up_button.style.opacity = "0";
        up_button.style.cursor = "inherit";
        up_button.removeEventListener('click',to_top)
      }
    };
    function to_top() {
      let start = Date.now();
      let timer = setInterval(function() {
        let timePassed = Date.now() - start;
        let time = 5000;
        let scrolled = window.pageYOffset || document.documentElement.scrollTop;
        if (timePassed >= time || scrolled <= 0) {
          console.log(timer);
          clearInterval(timer);
          return;
        }
        up (timePassed,time,scrolled);
      }, 10);
      function up(timePassed,time,scrolled) {
        if (scrolled > 0) {
          let x = scrolled - (scrolled*timePassed/(2*time));
          window.scrollTo(0,Math.floor(x));
        }
      }
    }
  }
// Сплит тестирование
  (function($) {
    $(".go_btn").click(function(){
      let data_count = $('#input-split').val();
      data_count = parseInt(data_count) + 1;
      $('#input-split').val(data_count);

      let ajaxurl = '/wp-admin/admin-ajax.php';
      let form = "#test-form";
      $.ajax({
        url: ajaxurl + "?action=split_function",
        type: 'POST',
        data: {'input-test' : $('#input-split').val()},
        success: function(data) {
          console.log("SUCCESS!");
        },
        error: function(data) {
          console.log("FAILURE");
        }
      });
    });
  })(jQuery);
});